export default __webpack_public_path__ + "static/media/IMG_4467.d1718456.jpeg";